import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import { TextField } from "@material-ui/core";
import { getServiceTypeList } from "../Actions/CommonAPI";
import MMPLShipCard from "./GrandAdminShipCard";
import DatePicker from "react-datepicker";
import FileSaver from "file-saver";
import Role from "../helpers/role";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipSearchlist,
  getMMPLShipCount,
  getMMPLShipDeatil,
  exportToExcel,
  getpendingShipSearchlist,
} from "../Actions/MMPLDashboardAPI";
import {
  getPendingShipCount,
} from "../Actions/ApproverScreenAPI";
import CountUp from "react-countup";
import { AutoComplete } from "primereact/autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import MapCharts from "./Mapchart";
import axios from "axios";
import API from "../helpers/api";
import moment from "moment";
import $ from "jquery";

let userrole = localStorage.getItem("UserRoles");
let currentuser = JSON.parse(localStorage.getItem("currentUser"));
class GrandAdminPendingDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSidePane: false,
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      allShipo: 100,
      expiredShips: 99,
      expiringShips: 50,
      toDate: "",
      clientList: [],
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      action: 1,
      portValue: [],
      originalPortData: {},
      markers: [],
      searchShip: {
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        client: "",
        status: "Pending",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
        action: 1,
      },
      shipData: {
        IsClient: false,
        mail: "",
        shipName: "",
      },
      inContract: false,
      notInContract: false,
      isBoth: true,
      isPopoveropen: false,
      selectedServiceTypes: [],
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
      serviceType: [],
      PageNo: 1,
    };
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.SearchMMPLData = this.SearchMMPLData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onChangeClientName = this.onChangeClientName.bind(this);
  }

  componentDidMount() {
    const { dispatch, searchData, searched } = this.props;
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Pending Ship Dashboard",
    });
    let BothResult = localStorage.getItem("SearchBothContract");
    let ContractResult = localStorage.getItem("SearchCotract");
    if (BothResult !== "") {
      this.state.isBoth = JSON.parse(BothResult);
    }
    if (ContractResult === "false" && BothResult !== "true") {
      this.state.inContract = JSON.parse(ContractResult);
      this.state.notInContract = true;
    } else if (ContractResult !== "") {
      this.state.inContract = JSON.parse(ContractResult);
    }

    this.setState({}, () => {
      console.log(this.state.inContract, this.state.notInContract, this.state.isBoth)
    })
    this.getClientList();
    let user = localStorage.getItem("UserRoles");
    if (user == Role.mmpl) {
      dispatch(getPendingShipCount(currentuser));
    }
    if (userrole === "approver") {
      this.state.searchShip.status = "waitingforapproval";
      this.setState({});
    }
    if (searchData) {
      this.state.searchShip = searchData;
      if (searchData.ServiceTypes != "") {
        this.state.selectedServiceTypes = searchData.ServiceTypes.split(",");
      }
      if (searched !== true) {
        this.ClearSearchField();
        dispatch({ type: "PendingsearchData", data: "" });
      }
    }
    this.setState({});
    dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth));
    dispatch({ type: "Pendingsearched", data: false });
    let searchitem = this.state.searchShip;
    let _this = this;
    $(document).keypress(function (event) {
      var keycode = event.keyCode || event.which;
      if (
        searchitem.shipName ||
        searchitem.client ||
        searchitem.imoNo ||
        searchitem.ServiceTypes.length > 0 ||
        searchitem.nextServiceDateFrom ||
        searchitem.nextServiceDateTo
      ) {
        if (keycode === 13) {
          _this.SearchMMPLData(1, 2);
        }
      }
    });
  }
  onChangeClientName = (event, value) => {
    this.setState({
      searchShip: {
        ...this.state.searchShip,
        client: value,
      },
    });
  };
  getClientList = () => {
    let url = `${API.Clientlist}`;
    axios
      .get(url)
      .then((response) => {
        this.state.clientList = response.data.clients;
        this.setState({})
      })
      .catch((error) => {
        console.log(error);
      });
  };
  toggle = (target, item) => {
    this.state.inContract = this.state.inContract;
    this.state.isBoth = this.state.isBoth;
    this.state.notInContract = this.state.notInContract;
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({
    });
  };
  handleRadioButtonChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "incontract") {
      this.state.inContract = true;
      this.state.notInContract = false;
      this.state.isBoth = false;
    }
    if (nodeName === "notcontract") {
      this.state.inContract = false;
      this.state.notInContract = true;
      this.state.isBoth = false;
    }
    if (nodeName === "both") {
      this.state.inContract = false;
      this.state.notInContract = false;
      this.state.isBoth = true;
    }
    this.setState({});
  };


  submitRequestContract = () => {
    const { dispatch } = this.props;
    localStorage.setItem("SearchCotract", this.state.inContract)
    localStorage.setItem("SearchBothContract", this.state.isBoth)
    dispatch(getMMPLShipCount(this.state.inContract, this.state.isBoth, ""));
    dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth));
    this.getMapInfo(this.state.inContract, this.state.isBoth)
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({})
  };
  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchShip[nodeName] = e.target.value;
    this.setState({});
  }

  serviceTypeChange(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.searchShip.Annually = true;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.searchShip.Annually = false;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked });
    this.setState({});
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  SearchMMPLData(pgno, noof) {
    const { dispatch } = this.props;
    const { searchShip, selectedServiceTypes } = this.state;
    searchShip["noofrecords"] = noof;
    searchShip["pagenumber"] = pgno;
    searchShip.ServiceTypes = selectedServiceTypes.join(",");
    this.setState(
      {
        searchShip: searchShip,
        filterShiplist: true,
      },
      () => {
        dispatch({ type: "PendingsearchData", data: this.state.searchShip });
        dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth));
        this.setState({});
      }
    );
  }

  onSelectChange = (item) => {
    this.setState({ selectedServiceTypes: item });
  };

  onRemoveChange(item) {
    this.setState({ selectedServiceTypes: item });
  }

  ClearSearchField() {
    const { dispatch } = this.props;
    this.setState(
      {
        searchShip: {
          IsClient: false,
          shipName: "",
          category: "",
          imoNo: "",
          client: "",
          status: "Pending",
          serviceStatus: "",
          nextServiceDateFrom: "",
          nextServiceDateTo: "",
          noofrecords: 2,
          pagesize: 25,
          pagenumber: 1,
          ServiceTypes: [],
          isTotalShips: this.state.searchShip.isTotalShips,
          isOverdueShips: this.state.searchShip.isOverdueShips,
          isShipsDue10: this.state.searchShip.isShipsDue10,
          isShipsDue30: this.state.searchShip.isShipsDue30,
          isShipsDue60: this.state.searchShip.isShipsDue60,
          isShipsDue90: this.state.searchShip.isShipsDue90,
          action: this.state.searchShip.action,
        },
        EquipmentName: "",
        selectedServiceTypes: [],
      },
      () => {
        dispatch({ type: "PendingsearchData", data: "" });
        this.state.selectedServiceTypes = [];
        this.setState({});
        dispatch(getpendingShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth));
      }
    );
    dispatch({ type: "PendingsearchData", data: "" });
  }

  render() {
    const {
      mmplShipSearchResult,
      mmplShipInfo,
      showSidePane,
      serviceTypeList,
      t
    } = this.props;
    const {
      isTotalShips,
      isOverdueShips,
      isShipsDue10,
      isShipsDue30,
      isShipsDue60,
      isShipsDue90,
    } = this.state.searchShip;
    const { selectedServiceTypes } = this.state;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header  mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("PendingShipScreenContent.PendingShipSearch")}
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6" : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("content.Shipname")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="shipName"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.shipName}
                            placeholder={t("content.Shipname")}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("content.Client")}</label>
                          <br></br>
                          <Autocomplete
                            value={this.state.searchShip.client}
                            options={this.state.clientList}
                            getOptionLabel={(option) => option || ""}
                            onChange={(event, value) => {
                              this.onChangeClientName(event, value);
                            }}
                            noOptionsText={"No options to display"}
                            freeSolo={false}
                            disableClearable
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className="form-control"
                                id="margin-dense"
                                style={{ marginTop: -1 }}
                                margin="dense"
                                size="small"
                                variant="outlined"
                                placeholder={t("content.Client")}
                              />
                            )}
                          />
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('content.IMOno')}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="imoNo"
                            placeholder={t('content.IMOno')}
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchShip.imoNo}
                          ></input>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t('content.Servicetype')}</label>
                          <Multiselect
                            options={serviceTypeList ?? []}
                            showArrow={true}
                            isObject={false}
                            style={{
                              option: {
                                marginRight: 0,
                                display: "block",
                                fontWeight: "normal",
                              },
                              chips: { "background-color": "#1a3464" },
                            }}
                            onSelect={(item) => this.onSelectChange(item)}
                            onRemove={(item) => this.onRemoveChange(item)}
                            selectedValues={selectedServiceTypes}
                            placeholder={
                              this.state.selectedServiceTypes &&
                                this.state.selectedServiceTypes.length
                                ? ""
                                : `${t('content.Select')}`
                            }
                            closeIcon="cancel"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={
                            showSidePane ? "col-sm-12 mt-4" : "col-lg-12 mt-4"
                          }>
                          <div
                            className="form-group search-btn-col"
                            style={{ textAlign: "end" }}>

                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                              type="submit"
                              onClick={() => this.SearchMMPLData(1, 2)}
                            >
                              {" "}
                              {t('content.Search')}{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearSearchField()}
                            >
                              {" "}
                              {t('content.Clear')}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {mmplShipSearchResult ? (
                <MMPLShipCard
                  arraylist={mmplShipSearchResult}
                  pageSize={mmplShipSearchResult.pagination.pageSize}
                  totalRecords={
                    mmplShipSearchResult.pagination.totalcount
                      ? mmplShipSearchResult.pagination.totalcount
                      : 0
                  }
                  setUpdatedState={(value, records) =>
                    this.SearchMMPLData(value, records)
                  }
                  shipMMPLInfo={mmplShipInfo}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    arraylist: state.SidePanReducer.arraylist,
    showSidePane: state.SidePanReducer.sidePan || false,
    searchData: state.SidePanReducer.PendingsearchData,

    searched: state.SidePanReducer.Pendingsearched || false,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI

    mmplShipDetail: state.MMPLDashboardReducer.MMPLShipDetail || {},
    mmplShipSearchResult:
      state.MMPLDashboardReducer.MMPLPendingShipSearchResult || null,
    mmplShipInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},

    serviceTypeList: state.MasterScreenReducer.applicableServiceTypeInterval || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(GrandAdminPendingDashboard));
